export enum CURRENCY_TYPE {
	EUR = "EUR",
	SEK = "SEK",
}
